import { Box, Typography, useMediaQuery, useTheme } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close";
import { animated, useSpring } from "react-spring";
import { DesktopNotificationProps } from "./types";
import { useMemo } from "react";
import { notificationStyles } from "./mockData";

const DesktopNotification = ({ label, options }: DesktopNotificationProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width: 681px)");
  const isLargeDesktop = useMediaQuery("(max-width: 1679px)");

  const [cardStyles] = useSpring(() => options.card, []);
  const [labelStyles] = useSpring(() => options.label, []);
  const [buttonStyles] = useSpring(() => options.button, []);
  const [timeStyles] = useSpring(() => options.time, []);

  const styles = useMemo(() => {
    if (isMobile) {
      return notificationStyles.xs;
    };
    if (isLargeDesktop) {
      return notificationStyles.lg;
    };
    return notificationStyles.xl;
  }, [isMobile, isLargeDesktop]);

  const AnimatedButton = animated((props) => (
    <CloseIcon
      {...props}
      sx={{
        color: theme.palette.text.secondary,
        ...styles.icon
      }}
    />
  ));
  const AnimatedLabel = animated((props) => (
    <Typography
      {...props}
      sx={{
        fontWeight: "600",
        color: theme.palette.text.secondary,
        ...styles.label
      }}
    >
      {label}
    </Typography>
  ));
  const AnimatedTime = animated((props) => (
    <Typography
      {...props}
      component="span"
      sx={{
        fontWeight: "600",
        color: theme.palette.text.secondary,
        ...styles.time
      }}
    >
      03:15 PM
    </Typography>
  ));
  const AnimatedCard = animated(({ children, ...props }) => (
    <Box
      {...props}
      sx={{
        position: "absolute",
        backgroundColor: theme.palette.common.white,
        boxSizing: "border-box",
        borderRadius: "5px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        overflow: "hidden",
        ...styles.container
      }}
    >
      {children}
    </Box>
  ));
  return (
    <AnimatedCard style={cardStyles}>
      <Box>
        <Box
          sx={{
            marginBottom: "5px",
            display: "flex",
            alignItems: "center"
          }}
        >
          <Typography
            component="span"
            sx={{
              fontWeight: "700",
              marginRight: "5px",
              ...styles.title
            }}
          >
            2021 Chevy Suburban
          </Typography>
          <AnimatedTime style={timeStyles} />
        </Box>
        <AnimatedLabel style={labelStyles} />
      </Box>
      <Box>
        <AnimatedButton style={buttonStyles} />
      </Box>
    </AnimatedCard>
  );
};

export default DesktopNotification;
